import { render } from "./CardDraw.vue?vue&type=template&id=653dc61e&scoped=true"
import script from "./CardDraw.vue?vue&type=script&lang=js"
export * from "./CardDraw.vue?vue&type=script&lang=js"

import "./CardDraw.vue?vue&type=style&index=0&id=653dc61e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653dc61e"]])

export default __exports__